import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Problem } from '../components/sections/Problem';
import { SystemOverview } from '../components/sections/SystemOverview';
import { Included } from '../components/sections/Included';
import { InteriorPreview } from '../components/sections/InteriorPreview';
import { Bonuses } from '../components/sections/Bonuses';
import { Differentiation } from '../components/sections/Differentiation';
import { Offer } from '../components/sections/Offer';
import { Guarantee } from '../components/sections/Guarantee';
import { Testimonials } from '../components/sections/Testimonials';
import { FaqSection } from '../components/sections/FaqSection';
import { FinalCta } from '../components/sections/FinalCta';
import { SiteFooter } from '../components/sections/SiteFooter';
export function Landing() {
  return <div className="w-full overflow-x-hidden bg-white font-sans" data-id="element-204" data-mp="h6nx2o39hj6e">
      <main data-id="element-205" data-mp="m8d843qhhwuh">
        <Hero data-id="element-206" data-mp="m7v42kxkyec0" />
        <Problem data-id="element-207" data-mp="m58z8t22qcxh" />
        <SystemOverview data-id="element-208" data-mp="29s8ai76rmxn" />
        <Included data-id="element-209" data-mp="2aa9zucmatcy" />
        <InteriorPreview data-id="element-210" data-mp="2atn8xrbotkn" />
        <Bonuses data-id="element-211" data-mp="27xlszg9nmrg" />
        <Differentiation data-id="element-212" data-mp="3tgbh5rtgp2tb" />
        <Offer data-id="element-213" data-mp="3tg1yyqenrzy6" />
        <Guarantee data-id="element-214" data-mp="3tfjw3axhqnha" />
        <Testimonials data-id="element-215" data-mp="3tf0drt3xhx2q" />
        <FaqSection data-id="element-216" data-mp="3peq7sgg4z6nv" />
        <FinalCta data-id="element-217" data-mp="3pe81eqzrfc28" />
      </main>
      <SiteFooter data-id="element-218" data-mp="3pfj6qv8usrvg" />
    </div>;
}